/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Link from '@material-ui/core/Link';
import { withStyles } from '@material-ui/core';
import { HandsFree } from '@tmna-ct/ipapps-core-js';
import styles from './styles';

class HandsFreeServices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes } = this.props;
    const phoneCall = HandsFree.callNumber('+14693887903');

    return (
      <div className={classes.container}>
        <br />
        <br />
        <h3>Hands Free :</h3>
        <br />
        <p>
          Action to test scheme calling functionalitie, tester should click Link and be able to
          perform a call.
        </p>
        <br />
        <Link href={phoneCall}>{`Calling ${phoneCall}`}</Link>
        <br />
        <br />
      </div>
    );
  }
}

HandsFreeServices.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HandsFreeServices);
